import { render } from "./examAnswerSheet.vue?vue&type=template&id=b9030f74&scoped=true"
import script from "./examAnswerSheet.vue?vue&type=script&lang=js"
export * from "./examAnswerSheet.vue?vue&type=script&lang=js"

import "./examAnswerSheet.vue?vue&type=style&index=0&id=b9030f74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9030f74"]])

export default __exports__